export default __webpack_public_path__ + "static/media/V410_CoC.18fb1bd2.pdf";